<template>
  <div class="body evel-II add-paper">
    <el-card class="box-card" shadow="never">
      <!-- <el-steps :active="step" simple>
        <el-step title="第一步：设置基础信息" icon="el-icon-edit"></el-step>
        <el-step title="第二步：大题设置" icon="el-icon-upload"></el-step>
        <el-step
          v-if="form.selectionMode == 1"
          title="第三步：试题设置"
          icon="el-icon-picture"
        ></el-step>
      </el-steps> -->

      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <div class="layer-header-front">
          <el-col :span="6" class="pr20">
            <el-form-item label="试卷编号" prop="paperNumber" class="item">
              <el-input v-model="form.paperNumber"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="试卷名称" prop="questionsPaperName">
              <el-input v-model="form.questionsPaperName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="pr20">
            <el-form-item>
              <el-button class="fa-pull-right" style="float: right;" @click="$router.back(-1)">返回</el-button>
            </el-form-item>
          </el-col>
          
        </div>
        <el-row class="pl20">
        <div>
         <span>&nbsp;</span>
          <h2 class="body-title"><span>基础信息</span></h2>
          <el-row>
            <el-col :span="6" class="pr20">
              <el-form-item label="抽题模式" prop="selectionMode" class="item">
                <el-select
                  :disabled="$route.query.type === 'edit'"
                  v-model="form.selectionMode"
                >
                  <el-option label="随机试题" value="0"></el-option>
                  <el-option label="固定试题" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="pr20">
              <el-form-item label="题库名称" prop="questionsDirectoryId">
                <selectTree
                  :props="{
                    value: 'id', // ID字段名
                    label: 'name' // 显示名称
                  }"
                  :options="catalogList"
                  :value="form.questionsDirectoryId"
                  @getValue="selectTreeChange"
                ></selectTree>
                <!-- <el-select
                  v-model="form.questionsDirectoryId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in catalogList"
                    :key="index"
                    :label="item.directoryName"
                    :value="item.id"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>


            <el-col :span="6" class="pr20">
              <el-tooltip class="item" effect="dark" content="不输入 或 输入 0 代表不限大题时间" placement="top-start">
                <el-form-item label="考试时长(分)" prop="examTime" class="item">
                  <el-input type="number" v-model="form.examTime" @blur="BlurText($event)" :min="0"></el-input>
                </el-form-item>
              </el-tooltip>
            </el-col>

<!--            <el-col :span="6" class="pr20">-->
<!--              <el-form-item label="是否开卷" prop="openBook" class="item">-->
<!--                <el-select v-model="form.openBook">-->
<!--                  <el-option label="开卷" value="0"></el-option>-->
<!--                  <el-option label="闭卷" value="1"></el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->

            <el-col :span="6" class="pr20">
              <el-form-item label="通过条件" prop="passCondition" class="item">
                <el-select v-model="form.passCondition" >
                  <el-option label="得分率" :value="0"></el-option>
                  <el-option label="合格分数" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="pr20" v-if="form.passCondition === 0">
              <el-form-item
                label="得分率"
                prop="passThroughRegulation"
                class="item"
              >
                <el-input-number
                  v-model="form.passThroughRegulation"
                  :min="0"
                  :max="100"
                  @input.native="onInput0_100"
                  placeholder="得分率不低于(%)"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="pr20" v-else>
              <el-form-item
                label="合格分数"
                prop="gradesThroughRegulation"
                class="item">
                <el-input
                  type="number"
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  v-model="form.gradesThroughRegulation"
                  :min="0"
                  placeholder="成绩不低于(分)"
                ></el-input>
              </el-form-item>
            </el-col>

          </el-row>

          <el-row>


            <!--            <el-col :span="6" class="pr20">-->
            <!--              <el-form-item label="部门" prop="departmentId">-->
            <!--                <selectTree-->
            <!--                  ref="selectTree"-->
            <!--                  :props="{-->
            <!--                    value: 'id', // ID字段名-->
            <!--                    label: 'text', // 显示名称-->
            <!--                    children: 'children' // 子级字段名-->
            <!--                  }"-->
            <!--                  :options="deptTree"-->
            <!--                  :value="form.departmentId"-->
            <!--                  @getValue="deptChange"-->
            <!--                ></selectTree>-->
            <!--                &lt;!&ndash; <el-select v-model="form.departmentId" placeholder="请选择">-->
            <!--                  <el-option-->
            <!--                    v-for="item in departmentList"-->
            <!--                    :key="item.id"-->
            <!--                    :label="item.deptName"-->
            <!--                    :value="item.id"-->
            <!--                  ></el-option>-->
            <!--                </el-select> &ndash;&gt;-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>

          <el-row>
            <el-col :span="6" class="pr20">
              <el-form-item
                label="难度系数"
                prop="degreeDifficulty"
                class="item"
              >
                <el-select v-model="form.degreeDifficulty" placeholder="请选择">
                  <el-option label="0" value="0"></el-option>
                  <el-option label="1" value="1"></el-option>
                  <el-option label="2" value="2"></el-option>
                  <el-option label="3" value="3"></el-option>
                  <el-option label="4" value="4"></el-option>
                  <el-option label="5" value="5"></el-option>
                  <el-option label="6" value="6"></el-option>
                  <el-option label="7" value="7"></el-option>
                  <el-option label="8" value="8"></el-option>
                  <el-option label="9" value="9"></el-option>
                  <el-option label="10" value="10"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!--            <el-col :span="6" class="pr20">-->
            <!--              <el-form-item-->
            <!--                label="过期时间"-->
            <!--                prop="expirationDateLong"-->
            <!--                class="item"-->
            <!--              >-->
            <!--                <el-date-picker-->
            <!--                  value-format="timestamp"-->
            <!--                  v-model="form.expirationDateLong"-->
            <!--                  type="datetime"-->
            <!--                  placeholder="选择日期"-->
            <!--                ></el-date-picker>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
          </el-row>

          <el-row>
            <el-col :span="12" class="pr20">
              <el-form-item label="备注" prop="remark" class="item">
                <el-input
                  v-model="form.remark"
                  type="textarea"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <div class="searchBut f-b-c">
            <span></span>
            <div>
              <el-button type="primary" @click="$router.go(-1)">返回</el-button>
              <el-button v-if="step < 3" type="primary" @click="toStep2"
              >下一步
              </el-button
              >
            </div>
          </div> -->
        </div>
        <div>
          <h2 class="body-title">大题设置</h2>

          <el-row>
            <el-button @click="addSubject(1)" icon="el-icon-plus"
            >单选题
            </el-button
            >
            <el-button @click="addSubject(2)" icon="el-icon-plus"
            >多选题
            </el-button
            >
            <el-button @click="addSubject(3)" icon="el-icon-plus"
            >判断题
            </el-button
            >
          </el-row>
          <el-table class="mb20" :data="subjectList" style="width: 100%">
            <el-table-column label="大题标题">
              <template slot-scope="scope">
                <el-input
                  v-model="subjectList[scope.$index].questionTitle"
                  placeholder
                ></el-input>
              </template>
            </el-table-column>
<!--            <el-table-column label="大题说明">-->
<!--              <template slot-scope="scope">-->
<!--                <el-input-->
<!--                  v-model="subjectList[scope.$index].questionRemark"-->
<!--                  placeholder-->
<!--                ></el-input>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column label="计划每题分数">
              <template slot-scope="scope">
                <el-input
                  v-model="subjectList[scope.$index].questionFraction"
                  placeholder
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="试题数">
              <template slot-scope="scope">
                <el-input
                  v-model="subjectList[scope.$index].questionNumber"
                  placeholder
                ></el-input>
              </template>
            </el-table-column>
<!--            <el-table-column label="每题时间">-->
<!--              <template slot-scope="scope">-->
<!--                <el-input-->
<!--                  v-model="subjectList[scope.$index].timeLimit"-->
<!--                  placeholder-->
<!--                ></el-input>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column label="总分">
              <template slot-scope="scope">
                <el-input
                  disabled
                  v-model="subjectList[scope.$index].questionFractionTotal"
                  placeholder
                ></el-input>
              </template>
            </el-table-column>

<!--            <el-table-column label="试题难度" v-if="form.selectionMode == 0">-->
<!--              <template slot-scope="scope">-->
<!--                <el-select-->
<!--                  v-model="subjectList[scope.$index].questionDifficulty"-->
<!--                  placeholder="请选择"-->
<!--                >-->
<!--                  <el-option label="0" value="0"></el-option>-->
<!--                  <el-option label="1" value="1"></el-option>-->
<!--                  <el-option label="2" value="2"></el-option>-->
<!--                  <el-option label="3" value="3"></el-option>-->
<!--                  <el-option label="4" value="4"></el-option>-->
<!--                  <el-option label="5" value="5"></el-option>-->
<!--                  <el-option label="6" value="6"></el-option>-->
<!--                  <el-option label="7" value="7"></el-option>-->
<!--                  <el-option label="8" value="8"></el-option>-->
<!--                  <el-option label="9" value="9"></el-option>-->
<!--                  <el-option label="10" value="10"></el-option>-->
<!--                </el-select>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column label="试题目录" v-if="form.selectionMode == 0">
              <template slot-scope="scope">
                <selectTree
                  :props="{
                    value: 'id', // ID字段名
                    label: 'directoryName', // 显示名称
                    children: 'directoryList' // 子级字段名
                  }"
                  :options="catalogList2"
                  :value="subjectList[scope.$index].directoryId"
                  @getValue="selectTreeChange4"
                  @focus="selectTreeIndexchange(scope.$index)"
                ></selectTree>
              </template>
            </el-table-column>-->

            <el-table-column label="操作" width="300">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  @click="upSubject(scope.$index)"
                >上移
                </el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="downSubject(scope.$index)"
                >下移
                </el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="delSubject(scope.$index)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <!-- <div class="searchBut f-b-c">
            <span></span>
            <div>
              <el-button type="primary" @click="$router.go(-1)">返回</el-button>
              <el-button type="primary" @click="lastStep">上一步</el-button>
              <el-button
                v-if="form.selectionMode == 1"
                type="primary"
                @click="toStep3"
              >下一步
              </el-button
              >
              <el-button v-else type="primary" @click="save">保存</el-button>
            </div>
          </div> -->
        </div>
      </el-row>
        <el-row>
        <div v-show="form.selectionMode == 1" style="padding: 20px">
          <h2 class="body-title">试题设置</h2>
          <el-col :span="6" class="pr20">
            <el-form label-width="120px">
              <el-form-item label="选择试题" prop="selectionMode">
                <el-select v-model="selectSubjectIndex">
                  <el-option
                    v-for="(item, index) in subjectList"
                    :key="index"
                    :label="item.questionTitle"
                    :value="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-button type="primary" @click="showLibrarySelector()"
            >添加试题
            </el-button>
          </el-col>

          <div class="mb20" v-for="(item, index) in questionList" :key="index">
            <el-table
              v-show="selectSubjectIndex == index"
              ref="singleChoiceTable"
              :data="item"
              style="width: 100%"
            >
              <el-table-column type="index" width="50" label="序号">
              </el-table-column>
              <el-table-column
                prop="questionNo"
                label="编号"
                width="100"
              ></el-table-column>
              <el-table-column prop="prop" label="题型" width="100">
                <template slot-scope="scope">{{
                    scope.row.questionType == 1
                      ? "单选题"
                      : scope.row.questionType == 2
                      ? "多选题"
                      : scope.row.questionType == 3
                        ? "判断题"
                        : "无"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="questionStemContent" label="试题内容">
                <template slot-scope="scope"
                >
                  <div v-html="item[scope.$index].questionStemContent"></div
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="分数"
                prop="questionFractionTotal"
                width="100"
              ></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="delQuestion(scope.$index)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- <div class="mb20" v-show="selectSubjectType == 2">
            <el-table
              ref="multipleChoiceTable"
              :data="multipleChoiceList"
              style="width: 100%"
            >
              <el-table-column prop="questionNo" label="编号"></el-table-column>
              <el-table-column prop="prop" label="题型">
                <template slot-scope="scope">{{
                  scope.row.questionType == 1
                    ? "单选题"
                    : scope.row.questionType == 2
                    ? "多选题"
                    : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
                }}</template>
              </el-table-column>
              <el-table-column
                prop="questionStemContent"
                label="试题内容"
              ></el-table-column>
              <el-table-column
                label="分数"
                prop="questionFractionTotal"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="delQuestion(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mb20" v-show="selectSubjectType == 3">
            <el-table
              ref="trueFlaseTable"
              :data="trueFlaseList"
              style="width: 100%"
            >
              <el-table-column prop="questionNo" label="编号"></el-table-column>
              <el-table-column prop="prop" label="题型">
                <template slot-scope="scope">{{
                  scope.row.questionType == 1
                    ? "单选题"
                    : scope.row.questionType == 2
                    ? "多选题"
                    : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
                }}</template>
              </el-table-column>
              <el-table-column
                prop="questionStemContent"
                label="试题内容"
              ></el-table-column>
              <el-table-column
                label="分数"
                prop="questionFractionTotal"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="delQuestion(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div> -->
        </div>
      </el-row>
        <el-row>
        <div class="searchBut">

            <!-- <el-button type="primary" @click="lastStep">上一步</el-button> -->
            <el-button type="primary" @click="save">保存</el-button>
            <el-button  @click="$router.go(-1)">取消</el-button>
  
        </div>
      </el-row>
      </el-form>
    </el-card>

    <el-dialog
      title="选择试题"
      :visible.sync="selectQuestionsVisible"
      width="70%"
      @close="closeDialog"
    >
      <el-form ref="questionForm" :model="questionForm" label-width="140px">
        <el-row>
          <el-col :span="10" class="pr20">
            <el-form-item label="试题编号" prop="questionNo">
              <el-input v-model="questionForm.questionNo"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="10" class="pr20">
            <el-form-item label="试题内容" prop="questionStemContent">
              <el-input v-model="questionForm.questionStemContent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10" class="pr20">
            <el-form-item label="目录" prop="directoryId">
              <selectTree
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList2"
                :value="form.questionsDirectoryId"
                @getValue="selectTreeChange2"
                ref="selectTree"
              ></selectTree>
              <!-- <el-select
                v-model="questionForm.directoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in catalogList2"
                  :key="index"
                  :label="item.directoryName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
<!--          <el-col :span="10" class="pr20">-->
<!--            <el-form-item label="课程" prop="trainingProgramId">-->
<!--              <el-select v-model="questionForm.trainingProgramId" placeholder="请选择">-->
<!--                <el-option-->
<!--                  v-for="item in trainingProgramOptions"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="10" class="pr20">
            <el-form-item>
              <el-button type="primary" @click="getLibraryListById"
              >搜索
              </el-button
              >
              <el-button type="primary" @click="resetForm('questionForm')"
              >重置
              </el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="mb20 pb50" v-show="selectSubjectType == 1">
        <el-table
          :data="singleList"
          style="width: 100%"
          class="mb20"
          @selection-change="singleListChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column
            prop="questionNo"
            label="编号"
            width="200"
          ></el-table-column>
          <el-table-column prop="prop" label="题型" width="200">
            <template slot-scope="scope">{{
                scope.row.questionType == 1
                  ? "单选题"
                  : scope.row.questionType == 2
                  ? "多选题"
                  : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column label="试题内容">
            <template slot-scope="scope"
            >
              <div v-html="singleList[scope.$index].questionStemContent"></div
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right;"
          background
          layout="total ,prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <div class="mb20 pb50" v-show="selectSubjectType == 2">
        <el-table
          ref="multipleChoiceTable"
          :data="multipleList"
          style="width: 100%"
          class="mb20"
          @selection-change="multipleListChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column
            prop="questionNo"
            label="编号"
            width="200"
          ></el-table-column>
          <el-table-column prop="prop" label="题型" width="200">
            <template slot-scope="scope">{{
                scope.row.questionType == 1
                  ? "单选题"
                  : scope.row.questionType == 2
                  ? "多选题"
                  : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column label="试题内容">
            <template slot-scope="scope"
            >
              <div
                v-html="multipleList[scope.$index].questionStemContent"
              ></div
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right;"
          background
          layout="total ,prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <div class="mb20 pb50" v-show="selectSubjectType == 3">
        <el-table
          ref="trueFlaseTable"
          :data="trueList"
          style="width: 100%"
          class="mb20"
          @selection-change="trueListChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column
            prop="questionNo"
            label="编号"
            width="200"
          ></el-table-column>
          <el-table-column prop="prop" label="题型" width="200">
            <template slot-scope="scope">{{
                scope.row.questionType == 1
                  ? "单选题"
                  : scope.row.questionType == 2
                  ? "多选题"
                  : scope.row.questionType == 3
                    ? "判断题"
                    : "无"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="questionStemContent" label="试题内容">
            <template slot-scope="scope">
              <div v-html="trueList[scope.$index].questionStemContent"></div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float:right;"
          background
          layout="total ,prev, pager, next"
          :total="total"
          :page-size="pageSize"
          @current-change="pageChange"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button @click="selectQuestionsVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectQuestion">确 定</el-button>
      </div>
    </el-dialog>

    <!--试题选择组件-->
    <librarySelector ref="librarySelector"  @confirm="confirmSelectQuestion"></librarySelector>
  </div>
</template>

<script>
/**
 selectionMode ：抽题方式
 questionsDirectoryId ：所属目录Id
 directoryName:目录名称
 questionsPaperName：试卷名称
 paperNumber：试卷编号
 examTime：考试时长
 openBook ：是否开卷
 degreeDifficulty ：难度系数
 passThroughRegulation ： 通过条件百分比
 gradesThroughRegulation ：通过成绩
 remark ： 备注
 label ：标签
 expirationDateLong ：过期时间
 trainingPaperSetups :考试规则 {
    questionType ：题型
    questionRemark : 题型备注
    questionFraction ：每题分数
    questionNumber ：题目数量
    timeLimit ：每题时限
    questionFractionTotal ：题目总分数
}
 trainingPaperLibs：{
    questionType ：题型
    questionLibraryId ：题库Id
    questionStemContent :试题题干内容
    questionFractionTotal ：题目分数
    busiId ：用户标签
}
 */
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
//题目选择器
import librarySelector from "@/pages/trainingManagement/component/librarySelector";


export default {
  components: {selectTree, librarySelector},
  data() {
    return {
      questionBankId:undefined,
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      selectCatalogue: {},
      dept: {},
      deptTree: [],
      selectQuestionsVisible: false,
      form: {
        selectionMode: '0',
        questionsDirectoryId: undefined,
        directoryId: undefined,
        directoryName: undefined,
        questionsPaperName: undefined,
        paperNumber: undefined,
        examTime: 0,
        openBook: 1,
        degreeDifficulty: undefined,
        passThroughRegulation: undefined,
        gradesThroughRegulation: undefined,
        remark: undefined,
        label: undefined,
        passCondition: 0,
        // expirationDateLong: undefined,
        // departmentId: undefined
      },
      rules: {
        passThroughRegulation: [{required: true, message: "请输入得分率"}],
        gradesThroughRegulation: [{required: true, message: "请输入合格分数"}],
        // departmentId: [{ required: true, message: "请输入" }],
        selectionMode: [{required: true, message: "请选择抽题模式"}],
        questionsDirectoryId: [{required: true, message: "请选择题库名称"}],
        directoryName: [{required: true, message: "请输入"}],
        questionsPaperName: [{required: true, message: "请输入试卷名称"}],
        paperNumber: [{required: true, message: "请输入试卷编号"}],
        // examTime: [{required: true, message: "请输入考试时长"}],
        openBook: [{required: true, message: "请选择是否开卷"}],
        degreeDifficulty: [{required: true, message: "请选择难度系数"}],
        // remark: [{required: true, message: "请输入备注"}],
        label: [{required: true, message: "请输入"}],
        passCondition: [{required: true, message: "请选择通过条件"}],
        // expirationDateLong: [{ required: true, message: "请输入" }]
      },
      step: 1,
      catalogList: [],
      catalogList2: [],
      trainingProgramOptions: [],
      subjectList: [],
      selectSubjectType: undefined,
      trainingPaperLibs: [],
      departmentList: [],

      // 弹窗勾选的列表数据
      selectSingleList: [],
      selectMultipleList: [],
      selectTrueList: [],
      selectTreeIndex: 0,

      // 弹窗中的列表数据
      singleList: [],
      multipleList: [],
      trueList: [],

      singleChoiceList: [],
      multipleChoiceList: [],
      trueFlaseList: [],

      questionList: [],
      selectSubjectIndex: 0,
      questionTypeList: [],
      questionForm: {
        questionNo: undefined,
        questionStemContent: undefined,
        trainingProgramId: undefined
      }
    };
  },
  mounted() {
    this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.questionTypeList = JSON.parse(
      localStorage.getItem("questionTypeList")
    );
    this.getCatalogList();
    this.getCatalogList2();
    this.getTrainingProgramOptions();

    if (this.$route.query.id) this.addPaperDetail();
  },
  methods: {
    onInput0_100(e) {
      this.$message.closeAll();
      if (e.target.value < 0 || e.target.value > 100) {
        this.$message.warning("得分率必须在[0,100]区间");
      }
      e.target.value = (e.target.value >= 0 && e.target.value <= 100 && e.target.value.match(/^\d{1,3}(\.\d*)?$/)[0]) || null;
    },

    BlurText(e) {
      let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value)
      if(!boolean) {
        this.$message.warn('请输入正整数')
        e.target.value = ' '
      }
    },
    // deptChange(v){
    //   this.dept = v;
    //   this.form.departmentId = v.id;
    // },
    selectTreeChange(v) {
      this.selectCatalogue = v;
      this.form.questionsDirectoryId = v.id;
      this.questionBankId = v.id;
    },
    selectTreeChange2(v) {
      this.questionForm.directoryId = v.id;
      this.questionForm.directoryName = v.text;
    },
    selectTreeChange3(v) {
      this.form.directoryId = v.id;
    },
    selectTreeChange4(v) {
      this.$set(this.subjectList[this.selectTreeIndex], "directoryId", v.id);
    },
    selectTreeIndexchange(index) {
      this.selectTreeIndex = index;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      if (formName === "questionForm") {
        this.$refs.selectTree.clearHandle();
        this.questionForm.directoryId = undefined;
      }
    },
    closeDialog() {
      this.$refs["questionForm"].resetFields();
    },
    pageChange(e) {
      this.page = e;
      this.getLibraryListById();
    },
    delQuestion(index) {
      this.questionList[this.selectSubjectIndex].splice(index, 1);
    },
    singleListChange(e) {
      this.selectSingleList = e;
    },
    multipleListChange(e) {
      this.selectMultipleList = e;
    },
    trueListChange(e) {
      this.selectTrueList = e;
    },
    confirmSelectQuestion(selectDataList){
      console.log('start  this.questionList ---- : %o',  this.questionList)
      // this.questionList[this.selectSubjectIndex] = [];
      //
      // selectDataList.forEach(v => {
      //   this.questionList[this.selectSubjectIndex].push(v);
      // });
      this.$set(this.questionList, this.selectSubjectIndex, selectDataList);
      console.log('end this.questionList ---- : %o',  this.questionList)
    },
    selectQuestion() {
      // let questionNumber = 0;
      // this.subjectList.forEach(v => {
      //   if (v.questionType == 1) {
      //     questionNumber = v.questionNumber;
      //   }
      // });
      let questionNumber = this.subjectList[this.selectSubjectIndex]
        .questionNumber;
      switch (parseInt(this.selectSubjectType)) {
        case 1:
          if ((this.questionList[this.selectSubjectIndex].length + this.selectSingleList.length) > questionNumber) {
            this.$message.error(`只能选择${questionNumber}个题目`);
            throw "error";
          }
          this.selectSingleList.forEach(v => {
            let canPush = true;
            this.questionList[this.selectSubjectIndex].forEach(v2 => {
              if (v.id == v2.id || v.id == v2.questionLibraryId)
                canPush = false;
            });
            canPush && this.questionList[this.selectSubjectIndex].push(v);
          });
          break;
        case 2:
          if ((this.questionList[this.selectSubjectIndex].length + this.selectSingleList.length) > questionNumber) {
            this.$message.error(`选择的试题数不能大于${questionNumber}题`);
            throw "error";
          }
          this.selectMultipleList.forEach(v => {
            let canPush = true;
            this.questionList[this.selectSubjectIndex].forEach(v2 => {
              if (v.id == v2.id || v.id == v2.questionLibraryId)
                canPush = false;
            });
            canPush && this.questionList[this.selectSubjectIndex].push(v);
          });
          break;
        case 3:
          if ((this.questionList[this.selectSubjectIndex].length + this.selectTrueList.length) > questionNumber) {
            this.$message.error(`选择的试题数不能大于${questionNumber}题`);
            throw "error";
          }

          this.selectTrueList.forEach(v => {
            let canPush = true;
            this.questionList[this.selectSubjectIndex].forEach(v2 => {
              if (v.id == v2.id || v.id == v2.questionLibraryId)
                canPush = false;
            });

            canPush && this.questionList[this.selectSubjectIndex].push(v);
          });
          break;
      }
      this.selectQuestionsVisible = false;
    },
    addPaperDetail() {
      exam.addPaperDetail({paperId: this.$route.query.id}).then(res => {
        this.form.selectionMode = String(res.data.selectionMode);
        this.form.questionsDirectoryId = res.data.questionsDirectoryId;
        this.form.directoryName = res.data.directoryName;
        this.form.questionsPaperName = res.data.questionsPaperName;
        this.form.paperNumber = res.data.paperNumber;

        this.form.examTime = res.data.examTime? res.data.examTime : 0;
        this.form.openBook = String(res.data.openBook);
        this.form.degreeDifficulty = res.data.degreeDifficulty;
        this.form.remark = res.data.remark;
        this.form.label = res.data.label;
        this.form.passCondition = res.data.passCondition;

        //判断通过条件
        if (this.form.passCondition == 0) {
          this.form.passThroughRegulation = res.data.passThroughRegulation;
        } else  {
          this.form.gradesThroughRegulation = res.data.gradesThroughRegulation;
        }
        // this.form.expirationDateLong = res.data.expirationDateLong;
        // this.form.departmentId = res.data.departmentId;
        this.subjectList = res.data.trainingPaperSetups;
        if (this.form.selectionMode == 1) {
          this.subjectList.forEach((v, i) => {
            delete this.subjectList[i].directoryId;
            delete this.subjectList[i].questionDifficulty;
          });
        }

        let temp = [];
        this.subjectList.forEach((v, i) => {
          // temp.push([]);
          this.questionList.push([]);
          res.data.trainingPaperLibs.forEach((v2, i2) => {
            if (v.id == v2.paperSetupId) {
              // temp[i].push(v2)
              this.$set(this.questionList[i], this.questionList[i].length, v2);
            }
          });
        });
        // this.questionList = temp
        // console.table(this.questionList)
      });
    },
    save() {
      let p = {
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
        ...this.form
      };

      if (this.form.passCondition == 0) {
        // 得分率
        p.passThroughRegulation = parseFloat(p.passThroughRegulation);
        delete p.gradesThroughRegulation;
      } else {
        // 合格分数
        p.gradesThroughRegulation = parseFloat(p.gradesThroughRegulation);
        delete p.passThroughRegulation;
      }
      // 所属目录
      if (p.questionsDirectoryId) {
        p.directoryName = this.selectCatalogue.text;
      }
      //部门
      p.department = this.dept.text;
      // this.departmentList.forEach(v => {
      //   if (v.id == p.departmentId) {
      //     p.department = v.deptName;
      //   }
      // });

      // 第二部:大体设置
      p.trainingPaperSetups = [];
      this.subjectList.forEach(v => {
        let prams = {
          questionTitle: v.questionTitle,
          // questionRemark: v.questionRemark,
          questionRemark: '--',
          questionFraction: v.questionFraction,
          questionNumber: v.questionNumber,
          questionType: v.questionType,
          // timeLimit: v.timeLimit,
          timeLimit: 0,
          questionFractionTotal: String(v.questionFractionTotal)
        };
        if (p.selectionMode == 0) {
          if (v.questionDifficulty) {
            prams.questionDifficulty = parseInt(v.questionDifficulty);
          } else {
            prams.questionDifficulty = this.form.degreeDifficulty
          }
          console.log("----form-----",this.form)

          console.log("---------",p)
          prams.directoryId = p.questionsDirectoryId;
        }
        p.trainingPaperSetups.push(prams);
      });

      // 如果是固定试题
      if (p.selectionMode == 1) {
        //固定试题
        p.trainingPaperLibs = [];
        this.questionList.forEach(v => {
          v.forEach(v2 => {
            p.trainingPaperLibs.push({
              questionType: v2.questionType,
              questionLibraryId: v2.questionLibraryId || v2.id,
              questionStemContent: v2.questionStemContent,
              questionFractionTotal: String(v2.questionFractionTotal)
              // busiId: v2.busiId//没有这个值
            });
          });
        });

        if (p.trainingPaperLibs.length == 0) {
          return this.$message.error("请添加试题");
        }
        p.trainingPaperLibs.forEach(v => {
          for (let key in v) {
            console.log(v[key]);
            if (!v[key]) {
              this.$message.error("请完善试题信息");
              throw "请完善试题信息";
            }
          }
        });
      }

      // if (p.trainingPaperSetups.length == 0)
      //   return this.$message.error("请添加大题");

      p.trainingPaperSetups.forEach(v => {
        for (let key in v) {
          if (!v[key] && v[key] != 0) {
            this.$message.error("请完善大题信息");
            throw "请完善大题信息";
          }
        }
      });
      if (this.form.selectionMode == 0) {
        this.subjectList.forEach((item, index) => {
          this.subjectList.forEach((item2, index2) => {
            if (
              index !== index2 &&
              item.questionType == item2.questionType &&
              item.questionFraction == item2.questionFraction
            ) {
              this.$message.error("同一类型大题,计划每题分数不能相同");
              throw "error";
            }
          });
        });
      }

      if (this.$route.query.id) {
        p.id = this.$route.query.id;
        exam.updatePaper(p).then(res => {
          if (res.code == 0) {
            this.$message.success("成功");
            this.$router.go(-1);
          } else {
            this.$message.error(res.message);
          }
        });
        return;
      }
      exam.addPaper(p).then(res => {
        if (res.code == 0) {
          this.$message.success("成功");
          this.$router.go(-1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getLibraryListById() {
      // if (!this.form.questionsDirectoryId)
      //   return this.$message.error("请选择所属目录");

      this.selectQuestionsVisible = true;
      exam.getQuestionBankList({
        questionType: this.subjectList[this.selectSubjectIndex].questionType,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
        page: this.page,
        pageSize: this.pageSize,
        ...this.questionForm
      })
        .then(res => {
          if (this.selectSubjectType == 1) {
            this.singleList = res.data.records;
            this.total = res.data.total;
            // this.singleList = res.data;
          }
          if (this.selectSubjectType == 2) {
            this.multipleList = res.data.records;
            this.total = res.data.total;
          }
          if (this.selectSubjectType == 3) {
            this.trueList = res.data.records;
            this.total = res.data.total;
          }
        });
    },
    showLibrarySelector() {
      this.$refs.librarySelector.show();
      this.$refs.librarySelector.setSelection(this.questionBankId ,this.questionList[this.selectSubjectIndex], this.subjectList[this.selectSubjectIndex].questionType, this.subjectList[this.selectSubjectIndex].questionNumber);
    },
    delSubject(index) {
      if (this.subjectList.length == 0) return;
      this.subjectList.splice(index, 1);

      if (this.questionList.length >= index + 1) {
        this.questionList.splice(index, 1);
      }
    },
    downSubject(index) {
      if (this.subjectList.length == 1 || this.subjectList.length == 0) return;
      if (this.subjectList.length - 1 == index) return;
      let temp = {
        ...this.subjectList[index]
      };
      this.$set(this.subjectList, index, this.subjectList[index + 1]);
      this.$set(this.subjectList, index + 1, temp);
    },
    upSubject(index) {
      if (this.subjectList.length == 1 || this.subjectList.length == 0) return;
      if (index == 0) return;
      let temp = {
        ...this.subjectList[index]
      };
      this.$set(this.subjectList, index, this.subjectList[index - 1]);
      this.$set(this.subjectList, index - 1, temp);
    },
    /**
     * type:1:单选题,2:多选题,3:判断题
     */
    addSubject(type) {

      let obj = {
        questionType: type,
        questionTitle: "",
        // questionTitle:
        //   type == 1
        //     ? `单选题${this.subjectList.length + 1}`
        //     : type == 2
        //     ? `多选题${this.subjectList.length + 1}`
        //     : `判断题${this.subjectList.length + 1}`,
        questionRemark: "--",
        questionFraction: "",
        questionNumber: "",
        // timeLimit: "",
        questionFractionTotal: ""
      };

      if (this.form.selectionMode == 0) {
        obj.questionDifficulty = "";
        obj.directoryId = "";
        if (this.subjectList.length > 0 ) {
          let subBl = false ;
          this.subjectList.forEach((item, index) => {
            if (item.questionType == obj.questionType ) {
              subBl = true
            }
          });
          if (subBl) {
            let str = obj.questionType==1?"单选":obj.questionType==2?"多选":"判断";
            return this.$message.error("随机试卷"+str+"题型不可重复!");
          }
        }
      }

      this.subjectList.push(obj);
    },
 /*   getCatalogList() {
      exam
        .getCatalogList({
          type: 2,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.catalogList = res.data;
        });
    },*/
    getCatalogList() {
      exam
        .getAllList()
        .then(res => {
          if (res.code === 0) {
            this.catalogList = res.data;
          }
        });
    },


    getCatalogList2() {
      exam.getCatalogList({
          type: 1,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.catalogList2 = res.data;
        });
    },
    getTrainingProgramOptions() {
      exam.getProgramOptions({})
        .then(res => {
          this.trainingProgramOptions = res.data;
        });
    },
    nextStep() {
      if (this.step < 3) this.step += 1;
      if (this.step == 3) this.getLibraryListById();
    },
    toStep2() {
      if (
        this.passCondition == 0 &&
        (this.form.passThroughRegulation === "" ||
          this.form.passThroughRegulation === undefined)
      ) {
        return this.$message.error("请输入得分率");
      }
      if (
        this.passCondition == 1 &&
        (this.form.gradesThroughRegulation === "" ||
          this.form.gradesThroughRegulation === undefined)
      ) {
        return this.$message.error("请输入合格分数");
      }

      if (this.passCondition == 0) delete this.rules.gradesThroughRegulation;
      if (this.passCondition == 1) delete this.rules.passThroughRegulation;
      this.$refs.form.validate(validate => {
        if (validate == false) return false;

        this.step += 1;
      });
    },
    toStep3() {
      if (this.subjectList.length == 0)
        return this.$message.error("请添加大题");

      this.subjectList.forEach(v => {
        for (let key in v) {
          if (key == '') {}
          if (v[key] === "" || v[key] === undefined || v[key] === null) {
            this.$message.error("请填写表格信息:"+v[key]);
            throw "error";
          }
        }
      });
      let questionFractionTotal  =  0;
      this.subjectList.forEach((item, index) => {
        questionFractionTotal += item.questionFractionTotal;
        this.subjectList.forEach((item2, index2) => {
          if (
            index !== index2 &&
            item.questionType == item2.questionType &&
            item.questionFraction == item2.questionFraction
          ) {
            this.$message.error("同一类型大题,计划每题分数不能相同");
            throw "error";
          }
        });
      });

      if (questionFractionTotal < this.form.gradesThroughRegulation) {
        this.$message.error("合格分数不能超过总分数，请重新设置总分数，或调整大题分数");
        throw "error";
      }

      this.step += 1;
      this.selectSubjectType = this.subjectList[0].questionType;

      // let temp = [];
      // this.subjectList.forEach(() => {
      //   temp.push([]);
      // });
      // this.questionList = temp;
      let len = this.subjectList.length - this.questionList.length;
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          this.questionList.push([]);
        }
      }
      if (len < 0) {
        this.questionList.length = this.subjectList.length;
      }
    },
    lastStep() {
      if (this.step > 1) this.step -= 1;
    }
  },
  watch: {
    'form.passCondition': {
      handler: function(val) {
        if (val == 0) { // 得分率
          this.$set(this.rules, 'passThroughRegulation', [{required: true, message: "请输入得分率"}]);
          this.$set(this.rules, 'gradesThroughRegulation', undefined);
        } else { // 合格分数
          this.$set(this.rules, 'gradesThroughRegulation', [{required: true, message: "请输入合格分数"}]);
          this.$set(this.rules, 'passThroughRegulation', undefined);
        }
      },
    },
    selectSubjectType() {
      this.page = 1;
      this.pageSize = 20;
      this.total = 0;
    },
    singleChoiceList(v) {
      let questionFractionTotal = 0;
      this.subjectList.forEach(v => {
        if (v.questionType == 1) {
          questionFractionTotal = v.questionFraction;
        }
      });

      this.singleChoiceList.forEach(v => {
        v.questionFractionTotal = questionFractionTotal;
      });
    },
    multipleChoiceList(v) {
      let questionFractionTotal = 0;
      this.subjectList.forEach(v => {
        if (v.questionType == 2) {
          questionFractionTotal = v.questionFraction;
        }
      });

      this.multipleChoiceList.forEach(v => {
        v.questionFractionTotal = questionFractionTotal;
      });
    },
    trueFlaseList(v) {
      let questionFractionTotal = 0;
      this.subjectList.forEach(v => {
        if (v.questionType == 3) {
          questionFractionTotal = v.questionFraction;
        }
      });

      this.trueFlaseList.forEach(v => {
        v.questionFractionTotal = questionFractionTotal;
      });
    },
    subjectList: {
      handler(v) {
        console.log(v);
        v.forEach((item, index) => {
          if (item.questionFraction > 0 && item.questionNumber > 0) {
            let temp =
              parseFloat(item.questionFraction) * parseInt(item.questionNumber);
            if (Number.isInteger(temp)) {
              item.questionFractionTotal = temp;
            } else {
              this.$message.error("总分必须是整数");
              item.questionFractionTotal = "";
            }
          } else {
            item.questionFractionTotal = "";
          }

          if (this.questionList && this.questionList.length > index) {
            this.questionList[index].forEach(v => {
              v.questionFractionTotal = item.questionFraction;
            });
          }
        });
      },
      deep: true
    },
    questionList: {
      handler(v) {
        let temp = this.subjectList[this.selectSubjectIndex].questionFraction;
        this.questionList[this.selectSubjectIndex].forEach(item => {
          item.questionFractionTotal = temp;
        });

        console.log(this.questionList);
      },
      deep: true
    }
  }
};
</script>

<style>
.body img {
  max-width: 100%;
}
.add-paper .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/examination/addPaper.vue